import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const OffersEndpoint = {
  getCasino: `/admin/casinos/list`,
  getCasinobyId: `/admin/casinos/casino/`,
  deleteCasino: `/admin/casinos/delete/`,
  editCasino: `/admin/casinos/edit/`,
  addCasino: `/admin/casinos/add`,
  uploadImage: `/admin/content/uploadImage`,
};

export const getCasino = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.getCasino, param);
  return Get(HomePageService, url, true);
};
export const getCasinobyId = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.getCasinobyId, param);
  return Get(HomePageService, url, true);
};
export const addCasino = (data, param = "") => {
  const url = getAPIUrl(OffersEndpoint.addCasino, param);
  return Post(HomePageService, url, data, true);
};

export const editCasino = (data, param = "") => {
  const url = getAPIUrl(OffersEndpoint.editCasino, param);
  return Put(HomePageService, url, data, true);
};

export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(OffersEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};
export const deleteCasino = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.deleteCasino, param);
  return Delete(HomePageService, url, param);
};
